export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/qgis.f7eef32.svg";